module.exports = __webpack_public_path__ + "static/media/FOOD PP - 2020 NOVO PORTI.e4bd178d.pdf";